import * as React from "react";
import { useTheme } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import { StyledTableCell, StyledTableRow } from "./Styles/TableAndCellStyles";
import { withoutSymbolFormatter } from "utilities/currencyFormatter";

function TablePaginationActions(props) {
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	return (
		<Box sx={{ flexShrink: 0, ml: 2.5 }}>
			<IconButton
				onClick={(event) => onPageChange(event, 0)}
				disabled={page === 0}
				aria-label="first page"
			>
				{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
			</IconButton>
			<IconButton
				onClick={(event) => onPageChange(event, page - 1)}
				disabled={page === 0}
				aria-label="previous page"
			>
				{theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
			</IconButton>
			<IconButton
				onClick={(event) => onPageChange(event, page + 1)}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page"
			>
				{theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
			</IconButton>
			<IconButton
				onClick={(event) =>
					onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
				}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page"
			>
				{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
			</IconButton>
		</Box>
	);
}

export default function ArrearsBreakdownTable({
	rows,
	count = 0,
	page = 0,
	rowsPerPage = 20,
	onPageChange,
	onRowsPerPageChange,
}) {
	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 700 }} aria-label="arrears table">
				<TableHead>
					<TableRow>
						<StyledTableCell>Tenant Name</StyledTableCell>
						<StyledTableCell align="left">RB Reference</StyledTableCell>
						<StyledTableCell align="left">Phone Number</StyledTableCell>
						<StyledTableCell align="left">Unit</StyledTableCell>
						<StyledTableCell align="left">Property</StyledTableCell>
						<StyledTableCell align="left">Landlord</StyledTableCell>
						<StyledTableCell align="left">Days Overdue</StyledTableCell>
						<StyledTableCell align="left">Amount in Arrears</StyledTableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.length === 0 ? (
						<TableRow>
							<TableCell colSpan={8} align="center">
								No tenants in arrears found.
							</TableCell>
						</TableRow>
					) : (
						rows.map((row) => (
							<StyledTableRow key={row.id}>
								<StyledTableCell component="th" scope="row">
									{row.tenant_name || "—"}
								</StyledTableCell>
								<StyledTableCell align="left">{row.tenant_number || "—"}</StyledTableCell>
								<StyledTableCell align="left">{row.phone_number || "—"}</StyledTableCell>
								<StyledTableCell align="left">{row.unit_name || "—"}</StyledTableCell>
								<StyledTableCell align="left">{row.property_name || "—"}</StyledTableCell>
								<StyledTableCell align="left">{row.landlord_name || "—"}</StyledTableCell>
								<StyledTableCell align="left">
									{row.days_left < 0 ? Math.abs(row.days_left) : 0}
								</StyledTableCell>
								<StyledTableCell align="left">
									{withoutSymbolFormatter(parseFloat(row.amount))}
								</StyledTableCell>
							</StyledTableRow>
						))
					)}
				</TableBody>
			</Table>
			<TablePagination
				rowsPerPageOptions={[10, 20, 50, 100]}
				component="div"
				count={count}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={onPageChange}
				onRowsPerPageChange={onRowsPerPageChange}
				ActionsComponent={TablePaginationActions}
				labelDisplayedRows={({ from, to, count: total }) =>
					`${from}–${to} of ${total !== -1 ? total : `more than ${to}`}`
				}
			/>
		</TableContainer>
	);
}
